<template>
  <div id="annonce-create-step-right-part" class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0">
    <div id="annonce-create-step-right-part-inside" class="w-100">
      <div class="col-12 pl-0 pr-0 mb-1">
        <b-form-group
          :label="$t('annonce.vehicle.need.image')"
          label-for="vehicleFiles-input"
          :invalid-feedback="imagesVehicleState.invalidFeedback"
          :state="imagesVehicleState.state"
          class="small-text">
          <b-form-file
            ref="vehicleFiles-input"
            id="vehicleFiles-input"
            :browse-text="$t('Select')"
            placeholder=""
            multiple
            @input="setAnnonce($event)"
            :drop-placeholder="$t('drop-placeholder')"
            required
            accept=".png, .jpeg, .jpg">
          </b-form-file>
        </b-form-group>
      </div>
      <div class="col-12 pl-0 pr-0 mb-2">
        <span class="custom-span-img" v-html="$t('annonce.vehicle.one.image')"></span>
      </div>
      <PreviewSeveralImages fileId="recto" :files="vehicleFiles" @deleteFileInPreview="deleteFile"></PreviewSeveralImages>

      <div class="col-12 pl-0 pr-0 mb-1 mt-4">
        <b-form-group
          :label="$t('annonce.vehicle.description')"
          label-for="description-vehicle-input"
          class="small-text">
          <b-form-textarea
            :state="vehicleDescription.state"
            id="description-vehicle-input"
            @change="setAnnonce"
            v-model="vehicleDescription.value">
          </b-form-textarea>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";
import PreviewSeveralImages from "../../../components/b122/showFields/PreviewSeveralImages"

export default {
  name: "AnnonceCreateStep6",

  components: {
    PreviewSeveralImages,
  },

  emits:["updateAnnonce"],

  props:{
    annonce : {
      required: true,
      type: Object
    }
  },

  data(){
    return {
      vehicleFiles : [],
      imagesVehicleState:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      vehicleDescription:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      _blobUrls: []
    }
  },

  async mounted() {
    const files = this.annonce && this.annonce.vehicleFiles ? this.annonce.vehicleFiles : []
    const resolved = await Promise.all(files.map(async (file) => {
      if (file && file.id) {
        const candidateUrl = file.fileUrl || file.url
        if (!candidateUrl) return { ...file }
        if (this.isAlreadyResolvedUrl(candidateUrl)) return { ...file, url: candidateUrl }
        const blobUrl = await this.loadProtectedFile(candidateUrl)
        return { ...file, url: blobUrl || null }
      } else {
        return { ...file }
      }
    }))
    this.vehicleFiles = resolved
    this.imagesVehicleState = this.annonce.imagesVehicleState
    this.vehicleDescription = this.annonce.vehicleDescription
  },

  beforeDestroy() {
    this.cleanupBlobs()
  },

  methods:{

    pushBlobUrl(u) {
      if (!u) return u
      if (!this._blobUrls) this._blobUrls = []
      this._blobUrls.push(u)
      return u
    },

    cleanupBlobs() {
      if (this._blobUrls && this._blobUrls.length) {
        this._blobUrls.forEach(u => { try { window.URL.revokeObjectURL(u) } catch (e) {} })
      }
      this._blobUrls = []
    },

    isAlreadyResolvedUrl(u) {
      return typeof u === 'string' && (u.startsWith('blob:') || u.startsWith('data:') || u.startsWith('http://') || u.startsWith('https://'))
    },

    async loadProtectedFile(fileUrl) {
      try {
        const res = await api.get(fileUrl, { responseType: 'blob' })
        return this.pushBlobUrl(window.URL.createObjectURL(res.data))
      } catch (e) {
        return null
      }
    },

    setAnnonce(event){
      if(event){
        event.forEach(file => {
          const fileUrl = this.pushBlobUrl(URL.createObjectURL(file))
          this.vehicleFiles.push({ url: fileUrl, file: file })
          this.imagesVehicleState.state = null
          this.imagesVehicleState.invalidFeedback = null
        })
      }
      this.$refs['vehicleFiles-input'].reset()
      this.annonce.vehicleFiles = this.vehicleFiles
      this.annonce.imagesVehicleState = this.imagesVehicleState
      this.annonce.vehicleDescription = this.vehicleDescription
      this.$emit('updateAnnonce', this.annonce)
    },

    deleteFile(index){
      const item = this.vehicleFiles && this.vehicleFiles[index] ? this.vehicleFiles[index] : null
      if (item && item.url && typeof item.url === 'string' && item.url.startsWith('blob:')) {
        try { window.URL.revokeObjectURL(item.url) } catch (e) {}
        if (this._blobUrls) this._blobUrls = this._blobUrls.filter(u => u !== item.url)
      }

      this.vehicleFiles.splice(index,1)
      this.annonce.vehicleFiles = this.vehicleFiles

      this.imagesVehicleState.state = null
      this.imagesVehicleState.invalidFeedback = null

      this.$emit('updateAnnonce', this.annonce)
    },

    // onFileInputChange() {
    //   const maxFilesAllowed = 3;
    //   const files = this.vehicleFiles;
    //   if (files && files.length > maxFilesAllowed) {
    //     this.vehicleFiles = files.slice(0, maxFilesAllowed);
    //   }
    // }

  },
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-step-right-part {
    height: 100%;
    overflow: auto;
  }
  #annonce-create-step-right-part-inside {
    padding-left: 3px; /* pour voir le border sur les input focus */
    width: 100%;
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
}

.custom-span-img{
  font-size: 14px;
  font-weight: 500;
  display: block;
  color: var(--main-grey-medium);
}

</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateStep6.vue